// decode obfuscated email string
const ksdecodeEmail = (encoded) => {
  let decoded = '';
  for (let i = 0; i < encoded.length; i++) {
    decoded += String.fromCharCode(encoded.charCodeAt(i) - 1);
  }
  return decoded;
};

// build mailto link and redirect
const ks_mlinkto = (encoded) => {
  let decoded = ksdecodeEmail(encoded);
  window.location.href = 'mailto:' + decoded;
};

// initialize email decoding for given selector
const initEmailAddress = (eleClass) => {
  console.log('init_email_address.jsv');

  // find all encoded email elements
  let emailLinks = document.querySelectorAll(eleClass);

  emailLinks.forEach(link => {
    let encodedEmail = link.getAttribute('data-enco-email');

    // replace href with mailto redirect
    link.href = 'javascript:ks_mlinkto(\'' + encodedEmail + '\')';

    // set decoded text as visible link text
    link.innerHTML = ksdecodeEmail(encodedEmail);
  });

  // expose redirect function globally
  window.ks_mlinkto = ks_mlinkto;
};

export default initEmailAddress;
